import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

export interface RouteNavigationData {
  _id?: string;
  id?: number | string;
  code?: string;
  name?: string;
  externalKeys?: {
    code?: string;
  };
}

export interface RouteQueryParams {
  search?: string;
  companyId?: string;
  status?: string;
  currentPage?: number;
  limitPerPage?: number;
  sort?: string;
  sortDirection?: 'asc' | 'desc';
  [key: string]: any;
}

export interface RouteNavigationEvent {
  data: RouteNavigationData;
  queryParams: RouteQueryParams;
  timestamp?: Date;
  source?: string;
}

@Injectable({
  providedIn: 'root',
})
export class RouteNavigationService {
  private readonly basePath: string[] = ['master', 'routing', 'route'];

  private readonly dialog = inject(MatDialog);

  constructor(private router: Router) {}

  navigateToRouteList(queryParams: RouteQueryParams = {}, openInNewTab: boolean = true): void {
    const urlTree = this.router.createUrlTree(this.basePath, { queryParams });

    if (openInNewTab) {
      const url = window.location.origin + this.router.serializeUrl(urlTree);
      window.open(url, '_blank');
    } else {
      // Same-tab navigation replaces the current page, so close any open dialog
      // (e.g. the document detail modal) that would otherwise float on top.
      this.dialog.closeAll();
      this.router.navigateByUrl(urlTree);
    }
  }

  navigateToRouteDetail(
    route: RouteNavigationData,
    additionalParams: RouteQueryParams = {},
    openInNewTab: boolean = true
  ): void {
    const filterValue = this.getRouteFilterValue(route);
    const queryParams: RouteQueryParams = {
      search: filterValue,
      ...additionalParams,
    };

    this.navigateToRouteList(queryParams, openInNewTab);
  }

  isRouteNavigable(route: RouteNavigationData | null | undefined): boolean {
    if (!route) return false;
    return !!route._id || !!route.id || !!route.code || !!route.externalKeys?.code || !!route.name;
  }

  getNavigationDescription(): string {
    return 'Ver detalle de Territorio';
  }

  private getRouteFilterValue(route: RouteNavigationData): string {
    if (!route) return '';
    return (
      route.externalKeys?.code ||
      route.code ||
      route.name ||
      (route.id != null ? String(route.id) : '')
    );
  }
}
